import { createAction } from '@reduxjs/toolkit';

export const inputChange = createAction('[PatientAdditionalInfo] inputChange');
export const autoSavePatientAdditionalDetails = createAction(
  '[PatientAdditionalInfo] autoSavePatientAdditionalDetails',
);
